/**
 * Supplier status values
 */
export enum SupplierStatusEnum {
	/**
	 * Supplier account is active and in good standing
	 */
	ACTIVE = 'active',
	/**
	 * Supplier account is on hold due to other reasons
	 */
	ON_HOLD = 'on_hold',
	/**
	 * Supplier account is closed
	 */
	CLOSED = 'closed',
}
